export const baseUrl = 'https://ri-software.com.ua/'
